<footer class="footer">
  <span id="footer-text">Développé par </span>
  <img id="footer-img" alt="VEOLIA" height="14" src="assets\logos\Veolia_Logo.png"/>
</footer>
